// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * The current status is always found in the current version of the resource, not the status history.
 */
export type IEncounterStatusHistory = fhir.IBackboneElement & {
  /**
   * The time that the episode was in the specified status.
   */
  period: fhir.IPeriod|null;
  /**
   * planned | arrived | triaged | in-progress | onleave | finished | cancelled +.
   */
  status: EncounterStatusHistoryStatusEnum|null;
  _status?: fhir.IFhirElement|undefined;
}
/**
 * The class history permits the tracking of the encounters transitions without needing to go  through the resource history.  This would be used for a case where an admission starts of as an emergency encounter, then transitions into an inpatient scenario. Doing this and not restarting a new encounter ensures that any lab/diagnostic results can more easily follow the patient and not require re-processing and not get lost or cancelled during a kind of discharge from emergency to inpatient.
 */
export type IEncounterClassHistory = fhir.IBackboneElement & {
  /**
   * inpatient | outpatient | ambulatory | emergency +.
   */
  class: fhir.ICoding|null;
  /**
   * The time that the episode was in the specified class.
   */
  period: fhir.IPeriod|null;
}
/**
 * The list of people responsible for providing the service.
 */
export type IEncounterParticipant = fhir.IBackboneElement & {
  /**
   * Persons involved in the encounter other than the patient.
   */
  individual?: fhir.IReference|undefined;
  /**
   * The period of time that the specified participant participated in the encounter. These can overlap or be sub-sets of the overall encounter's period.
   */
  period?: fhir.IPeriod|undefined;
  /**
   * The participant type indicates how an individual participates in an encounter. It includes non-practitioner participants, and for practitioners this is to describe the action type in the context of this encounter (e.g. Admitting Dr, Attending Dr, Translator, Consulting Dr). This is different to the practitioner roles which are functional roles, derived from terms of employment, education, licensing, etc.
   */
  type?: fhir.ICodeableConcept[]|undefined;
}
/**
 * The list of diagnosis relevant to this encounter.
 */
export type IEncounterDiagnosis = fhir.IBackboneElement & {
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  condition: fhir.IReference|null;
  /**
   * Ranking of the diagnosis (for each role type).
   */
  rank?: number|undefined;
  _rank?: fhir.IFhirElement|undefined;
  /**
   * Role that this diagnosis has within the encounter (e.g. admission, billing, discharge …).
   */
  use?: fhir.ICodeableConcept|undefined;
}
/**
 * An Encounter may cover more than just the inpatient stay. Contexts such as outpatients, community clinics, and aged care facilities are also included.
 * The duration recorded in the period of this encounter covers the entire scope of this hospitalization record.
 */
export type IEncounterHospitalization = fhir.IBackboneElement & {
  /**
   * From where patient was admitted (physician referral, transfer).
   */
  admitSource?: fhir.ICodeableConcept|undefined;
  /**
   * Location/organization to which the patient is discharged.
   */
  destination?: fhir.IReference|undefined;
  /**
   * For example, a patient may request both a dairy-free and nut-free diet preference (not mutually exclusive).
   */
  dietPreference?: fhir.ICodeableConcept[]|undefined;
  /**
   * Category or kind of location after discharge.
   */
  dischargeDisposition?: fhir.ICodeableConcept|undefined;
  /**
   * The location/organization from which the patient came before admission.
   */
  origin?: fhir.IReference|undefined;
  /**
   * Pre-admission identifier.
   */
  preAdmissionIdentifier?: fhir.IIdentifier|undefined;
  /**
   * Whether this hospitalization is a readmission and why if known.
   */
  reAdmission?: fhir.ICodeableConcept|undefined;
  /**
   * Any special requests that have been made for this hospitalization encounter, such as the provision of specific equipment or other things.
   */
  specialArrangement?: fhir.ICodeableConcept[]|undefined;
  /**
   * Special courtesies (VIP, board member).
   */
  specialCourtesy?: fhir.ICodeableConcept[]|undefined;
}
/**
 * Virtual encounters can be recorded in the Encounter by specifying a location reference to a location of type "kind" such as "client's home" and an encounter.class = "virtual".
 */
export type IEncounterLocation = fhir.IBackboneElement & {
  /**
   * The location where the encounter takes place.
   */
  location: fhir.IReference|null;
  /**
   * Time period during which the patient was present at the location.
   */
  period?: fhir.IPeriod|undefined;
  /**
   * This information is de-normalized from the Location resource to support the easier understanding of the encounter resource and processing in messaging or query.
   * There may be many levels in the hierachy, and this may only pic specific levels that are required for a specific usage scenario.
   */
  physicalType?: fhir.ICodeableConcept|undefined;
  /**
   * When the patient is no longer active at a location, then the period end date is entered, and the status may be changed to completed.
   */
  status?: EncounterLocationStatusEnum|undefined;
  _status?: fhir.IFhirElement|undefined;
}
/**
 * An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.
 */
export type IEncounter = fhir.IDomainResource & {
  /**
   * Resource Type Name
   */
  resourceType: "Encounter";
  /**
   * The billing system may choose to allocate billable items associated with the Encounter to different referenced Accounts based on internal business rules.
   */
  account?: fhir.IReference[]|undefined;
  /**
   * The appointment that scheduled this encounter.
   */
  appointment?: fhir.IReference[]|undefined;
  /**
   * The request this encounter satisfies (e.g. incoming referral or procedure request).
   */
  basedOn?: fhir.IReference[]|undefined;
  /**
   * Concepts representing classification of patient encounter such as ambulatory (outpatient), inpatient, emergency, home health or others due to local variations.
   */
  class: fhir.ICoding|null;
  /**
   * The class history permits the tracking of the encounters transitions without needing to go  through the resource history.  This would be used for a case where an admission starts of as an emergency encounter, then transitions into an inpatient scenario. Doing this and not restarting a new encounter ensures that any lab/diagnostic results can more easily follow the patient and not require re-processing and not get lost or cancelled during a kind of discharge from emergency to inpatient.
   */
  classHistory?: fhir.IEncounterClassHistory[]|undefined;
  /**
   * The list of diagnosis relevant to this encounter.
   */
  diagnosis?: fhir.IEncounterDiagnosis[]|undefined;
  /**
   * Where a specific encounter should be classified as a part of a specific episode(s) of care this field should be used. This association can facilitate grouping of related encounters together for a specific purpose, such as government reporting, issue tracking, association via a common problem.  The association is recorded on the encounter as these are typically created after the episode of care and grouped on entry rather than editing the episode of care to append another encounter to it (the episode of care could span years).
   */
  episodeOfCare?: fhir.IReference[]|undefined;
  /**
   * An Encounter may cover more than just the inpatient stay. Contexts such as outpatients, community clinics, and aged care facilities are also included.
   * The duration recorded in the period of this encounter covers the entire scope of this hospitalization record.
   */
  hospitalization?: fhir.IEncounterHospitalization|undefined;
  /**
   * Identifier(s) by which this encounter is known.
   */
  identifier?: fhir.IIdentifier[]|undefined;
  /**
   * May differ from the time the Encounter.period lasted because of leave of absence.
   */
  length?: fhir.IDuration|undefined;
  /**
   * Virtual encounters can be recorded in the Encounter by specifying a location reference to a location of type "kind" such as "client's home" and an encounter.class = "virtual".
   */
  location?: fhir.IEncounterLocation[]|undefined;
  /**
   * The list of people responsible for providing the service.
   */
  participant?: fhir.IEncounterParticipant[]|undefined;
  /**
   * This is also used for associating a child's encounter back to the mother's encounter.
   * Refer to the Notes section in the Patient resource for further details.
   */
  partOf?: fhir.IReference|undefined;
  /**
   * If not (yet) known, the end of the Period may be omitted.
   */
  period?: fhir.IPeriod|undefined;
  /**
   * Indicates the urgency of the encounter.
   */
  priority?: fhir.ICodeableConcept|undefined;
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  reasonCode?: fhir.ICodeableConcept[]|undefined;
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  reasonReference?: fhir.IReference[]|undefined;
  /**
   * The organization that is primarily responsible for this Encounter's services. This MAY be the same as the organization on the Patient record, however it could be different, such as if the actor performing the services was from an external organization (which may be billed seperately) for an external consultation.  Refer to the example bundle showing an abbreviated set of Encounters for a colonoscopy.
   */
  serviceProvider?: fhir.IReference|undefined;
  /**
   * Broad categorization of the service that is to be provided (e.g. cardiology).
   */
  serviceType?: fhir.ICodeableConcept|undefined;
  /**
   * Note that internal business rules will determine the appropriate transitions that may occur between statuses (and also classes).
   */
  status: EncounterStatusEnum|null;
  _status?: fhir.IFhirElement|undefined;
  /**
   * The current status is always found in the current version of the resource, not the status history.
   */
  statusHistory?: fhir.IEncounterStatusHistory[]|undefined;
  /**
   * While the encounter is always about the patient, the patient might not actually be known in all contexts of use, and there may be a group of patients that could be anonymous (such as in a group therapy for Alcoholics Anonymous - where the recording of the encounter could be used for billing on the number of people/staff and not important to the context of the specific patients) or alternately in veterinary care a herd of sheep receiving treatment (where the animals are not individually tracked).
   */
  subject?: fhir.IReference|undefined;
  /**
   * Since there are many ways to further classify encounters, this element is 0..*.
   */
  type?: fhir.ICodeableConcept[]|undefined;
}
/**
 * The current status is always found in the current version of the resource, not the status history.
 */
export class EncounterStatusHistory extends fhir.BackboneElement implements fhir.IEncounterStatusHistory {
  /**
   * The time that the episode was in the specified status.
   */
  public period: fhir.Period|null;
  /**
   * planned | arrived | triaged | in-progress | onleave | finished | cancelled +.
   */
  public status: EncounterStatusHistoryStatusEnum|null;
  public _status?: fhir.FhirElement|undefined;
  /**
   * Default constructor for EncounterStatusHistory - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterStatusHistory> = {}) {
    super(source);
    this.period = null;
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (this.period === undefined) { this.period = null }
    this.status = null;
    if (source["status"]) { this.status = source.status; }
    if (this.status === undefined) { this.status = null }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
  }
  /**
   * Check if the current EncounterStatusHistory contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["period"] === undefined) { missingElements.push("period"); }
    if (this["status"] === undefined) { missingElements.push("status"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterStatusHistory from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterStatusHistory):EncounterStatusHistory {
    var dest:EncounterStatusHistory = new EncounterStatusHistory(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterStatusHistory is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * The class history permits the tracking of the encounters transitions without needing to go  through the resource history.  This would be used for a case where an admission starts of as an emergency encounter, then transitions into an inpatient scenario. Doing this and not restarting a new encounter ensures that any lab/diagnostic results can more easily follow the patient and not require re-processing and not get lost or cancelled during a kind of discharge from emergency to inpatient.
 */
export class EncounterClassHistory extends fhir.BackboneElement implements fhir.IEncounterClassHistory {
  /**
   * inpatient | outpatient | ambulatory | emergency +.
   */
  public class: fhir.Coding|null;
  /**
   * The time that the episode was in the specified class.
   */
  public period: fhir.Period|null;
  /**
   * Default constructor for EncounterClassHistory - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterClassHistory> = {}) {
    super(source);
    this.class = null;
    if (source["class"]) { this.class = new fhir.Coding(source.class!); }
    if (this.class === undefined) { this.class = null }
    this.period = null;
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (this.period === undefined) { this.period = null }
  }
  /**
   * Check if the current EncounterClassHistory contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["class"] === undefined) { missingElements.push("class"); }
    if (this["period"] === undefined) { missingElements.push("period"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterClassHistory from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterClassHistory):EncounterClassHistory {
    var dest:EncounterClassHistory = new EncounterClassHistory(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterClassHistory is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * The list of people responsible for providing the service.
 */
export class EncounterParticipant extends fhir.BackboneElement implements fhir.IEncounterParticipant {
  /**
   * Persons involved in the encounter other than the patient.
   */
  public individual?: fhir.Reference|undefined;
  /**
   * The period of time that the specified participant participated in the encounter. These can overlap or be sub-sets of the overall encounter's period.
   */
  public period?: fhir.Period|undefined;
  /**
   * The participant type indicates how an individual participates in an encounter. It includes non-practitioner participants, and for practitioners this is to describe the action type in the context of this encounter (e.g. Admitting Dr, Attending Dr, Translator, Consulting Dr). This is different to the practitioner roles which are functional roles, derived from terms of employment, education, licensing, etc.
   */
  public type?: fhir.CodeableConcept[]|undefined;
  /**
   * Default constructor for EncounterParticipant - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterParticipant> = {}) {
    super(source);
    if (source["individual"]) { this.individual = new fhir.Reference(source.individual!); }
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (source["type"]) { this.type = source.type.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
  }
  /**
   * Check if the current EncounterParticipant contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterParticipant from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterParticipant):EncounterParticipant {
    var dest:EncounterParticipant = new EncounterParticipant(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterParticipant is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * The list of diagnosis relevant to this encounter.
 */
export class EncounterDiagnosis extends fhir.BackboneElement implements fhir.IEncounterDiagnosis {
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  public condition: fhir.Reference|null;
  /**
   * Ranking of the diagnosis (for each role type).
   */
  public rank?: number|undefined;
  public _rank?: fhir.FhirElement|undefined;
  /**
   * Role that this diagnosis has within the encounter (e.g. admission, billing, discharge …).
   */
  public use?: fhir.CodeableConcept|undefined;
  /**
   * Default constructor for EncounterDiagnosis - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterDiagnosis> = {}) {
    super(source);
    this.condition = null;
    if (source["condition"]) { this.condition = new fhir.Reference(source.condition!); }
    if (this.condition === undefined) { this.condition = null }
    if (source["rank"]) { this.rank = source.rank; }
    if (source["_rank"]) { this._rank = new fhir.FhirElement(source._rank!); }
    if (source["use"]) { this.use = new fhir.CodeableConcept(source.use!); }
  }
  /**
   * Check if the current EncounterDiagnosis contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["condition"] === undefined) { missingElements.push("condition"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterDiagnosis from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterDiagnosis):EncounterDiagnosis {
    var dest:EncounterDiagnosis = new EncounterDiagnosis(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterDiagnosis is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * An Encounter may cover more than just the inpatient stay. Contexts such as outpatients, community clinics, and aged care facilities are also included.
 * The duration recorded in the period of this encounter covers the entire scope of this hospitalization record.
 */
export class EncounterHospitalization extends fhir.BackboneElement implements fhir.IEncounterHospitalization {
  /**
   * From where patient was admitted (physician referral, transfer).
   */
  public admitSource?: fhir.CodeableConcept|undefined;
  /**
   * Location/organization to which the patient is discharged.
   */
  public destination?: fhir.Reference|undefined;
  /**
   * For example, a patient may request both a dairy-free and nut-free diet preference (not mutually exclusive).
   */
  public dietPreference?: fhir.CodeableConcept[]|undefined;
  /**
   * Category or kind of location after discharge.
   */
  public dischargeDisposition?: fhir.CodeableConcept|undefined;
  /**
   * The location/organization from which the patient came before admission.
   */
  public origin?: fhir.Reference|undefined;
  /**
   * Pre-admission identifier.
   */
  public preAdmissionIdentifier?: fhir.Identifier|undefined;
  /**
   * Whether this hospitalization is a readmission and why if known.
   */
  public reAdmission?: fhir.CodeableConcept|undefined;
  /**
   * Any special requests that have been made for this hospitalization encounter, such as the provision of specific equipment or other things.
   */
  public specialArrangement?: fhir.CodeableConcept[]|undefined;
  /**
   * Special courtesies (VIP, board member).
   */
  public specialCourtesy?: fhir.CodeableConcept[]|undefined;
  /**
   * Default constructor for EncounterHospitalization - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterHospitalization> = {}) {
    super(source);
    if (source["admitSource"]) { this.admitSource = new fhir.CodeableConcept(source.admitSource!); }
    if (source["destination"]) { this.destination = new fhir.Reference(source.destination!); }
    if (source["dietPreference"]) { this.dietPreference = source.dietPreference.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["dischargeDisposition"]) { this.dischargeDisposition = new fhir.CodeableConcept(source.dischargeDisposition!); }
    if (source["origin"]) { this.origin = new fhir.Reference(source.origin!); }
    if (source["preAdmissionIdentifier"]) { this.preAdmissionIdentifier = new fhir.Identifier(source.preAdmissionIdentifier!); }
    if (source["reAdmission"]) { this.reAdmission = new fhir.CodeableConcept(source.reAdmission!); }
    if (source["specialArrangement"]) { this.specialArrangement = source.specialArrangement.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["specialCourtesy"]) { this.specialCourtesy = source.specialCourtesy.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
  }
  /**
   * Check if the current EncounterHospitalization contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterHospitalization from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterHospitalization):EncounterHospitalization {
    var dest:EncounterHospitalization = new EncounterHospitalization(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterHospitalization is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Virtual encounters can be recorded in the Encounter by specifying a location reference to a location of type "kind" such as "client's home" and an encounter.class = "virtual".
 */
export class EncounterLocation extends fhir.BackboneElement implements fhir.IEncounterLocation {
  /**
   * The location where the encounter takes place.
   */
  public location: fhir.Reference|null;
  /**
   * Time period during which the patient was present at the location.
   */
  public period?: fhir.Period|undefined;
  /**
   * This information is de-normalized from the Location resource to support the easier understanding of the encounter resource and processing in messaging or query.
   * There may be many levels in the hierachy, and this may only pic specific levels that are required for a specific usage scenario.
   */
  public physicalType?: fhir.CodeableConcept|undefined;
  /**
   * When the patient is no longer active at a location, then the period end date is entered, and the status may be changed to completed.
   */
  public status?: EncounterLocationStatusEnum|undefined;
  public _status?: fhir.FhirElement|undefined;
  /**
   * Default constructor for EncounterLocation - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounterLocation> = {}) {
    super(source);
    this.location = null;
    if (source["location"]) { this.location = new fhir.Reference(source.location!); }
    if (this.location === undefined) { this.location = null }
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (source["physicalType"]) { this.physicalType = new fhir.CodeableConcept(source.physicalType!); }
    if (source["status"]) { this.status = source.status; }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
  }
  /**
   * Check if the current EncounterLocation contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["location"] === undefined) { missingElements.push("location"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a EncounterLocation from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounterLocation):EncounterLocation {
    var dest:EncounterLocation = new EncounterLocation(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `EncounterLocation is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.
 */
export class Encounter extends fhir.DomainResource implements fhir.IEncounter {
  /**
   * Resource Type Name
   */
  public override resourceType: "Encounter";
  /**
   * The billing system may choose to allocate billable items associated with the Encounter to different referenced Accounts based on internal business rules.
   */
  public account?: fhir.Reference[]|undefined;
  /**
   * The appointment that scheduled this encounter.
   */
  public appointment?: fhir.Reference[]|undefined;
  /**
   * The request this encounter satisfies (e.g. incoming referral or procedure request).
   */
  public basedOn?: fhir.Reference[]|undefined;
  /**
   * Concepts representing classification of patient encounter such as ambulatory (outpatient), inpatient, emergency, home health or others due to local variations.
   */
  public class: fhir.Coding|null;
  /**
   * The class history permits the tracking of the encounters transitions without needing to go  through the resource history.  This would be used for a case where an admission starts of as an emergency encounter, then transitions into an inpatient scenario. Doing this and not restarting a new encounter ensures that any lab/diagnostic results can more easily follow the patient and not require re-processing and not get lost or cancelled during a kind of discharge from emergency to inpatient.
   */
  public classHistory?: fhir.EncounterClassHistory[]|undefined;
  /**
   * The list of diagnosis relevant to this encounter.
   */
  public diagnosis?: fhir.EncounterDiagnosis[]|undefined;
  /**
   * Where a specific encounter should be classified as a part of a specific episode(s) of care this field should be used. This association can facilitate grouping of related encounters together for a specific purpose, such as government reporting, issue tracking, association via a common problem.  The association is recorded on the encounter as these are typically created after the episode of care and grouped on entry rather than editing the episode of care to append another encounter to it (the episode of care could span years).
   */
  public episodeOfCare?: fhir.Reference[]|undefined;
  /**
   * An Encounter may cover more than just the inpatient stay. Contexts such as outpatients, community clinics, and aged care facilities are also included.
   * The duration recorded in the period of this encounter covers the entire scope of this hospitalization record.
   */
  public hospitalization?: fhir.EncounterHospitalization|undefined;
  /**
   * Identifier(s) by which this encounter is known.
   */
  public identifier?: fhir.Identifier[]|undefined;
  /**
   * May differ from the time the Encounter.period lasted because of leave of absence.
   */
  public length?: fhir.Duration|undefined;
  /**
   * Virtual encounters can be recorded in the Encounter by specifying a location reference to a location of type "kind" such as "client's home" and an encounter.class = "virtual".
   */
  public location?: fhir.EncounterLocation[]|undefined;
  /**
   * The list of people responsible for providing the service.
   */
  public participant?: fhir.EncounterParticipant[]|undefined;
  /**
   * This is also used for associating a child's encounter back to the mother's encounter.
   * Refer to the Notes section in the Patient resource for further details.
   */
  public partOf?: fhir.Reference|undefined;
  /**
   * If not (yet) known, the end of the Period may be omitted.
   */
  public period?: fhir.Period|undefined;
  /**
   * Indicates the urgency of the encounter.
   */
  public priority?: fhir.CodeableConcept|undefined;
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  public reasonCode?: fhir.CodeableConcept[]|undefined;
  /**
   * For systems that need to know which was the primary diagnosis, these will be marked with the standard extension primaryDiagnosis (which is a sequence value rather than a flag, 1 = primary diagnosis).
   */
  public reasonReference?: fhir.Reference[]|undefined;
  /**
   * The organization that is primarily responsible for this Encounter's services. This MAY be the same as the organization on the Patient record, however it could be different, such as if the actor performing the services was from an external organization (which may be billed seperately) for an external consultation.  Refer to the example bundle showing an abbreviated set of Encounters for a colonoscopy.
   */
  public serviceProvider?: fhir.Reference|undefined;
  /**
   * Broad categorization of the service that is to be provided (e.g. cardiology).
   */
  public serviceType?: fhir.CodeableConcept|undefined;
  /**
   * Note that internal business rules will determine the appropriate transitions that may occur between statuses (and also classes).
   */
  public status: EncounterStatusEnum|null;
  public _status?: fhir.FhirElement|undefined;
  /**
   * The current status is always found in the current version of the resource, not the status history.
   */
  public statusHistory?: fhir.EncounterStatusHistory[]|undefined;
  /**
   * While the encounter is always about the patient, the patient might not actually be known in all contexts of use, and there may be a group of patients that could be anonymous (such as in a group therapy for Alcoholics Anonymous - where the recording of the encounter could be used for billing on the number of people/staff and not important to the context of the specific patients) or alternately in veterinary care a herd of sheep receiving treatment (where the animals are not individually tracked).
   */
  public subject?: fhir.Reference|undefined;
  /**
   * Since there are many ways to further classify encounters, this element is 0..*.
   */
  public type?: fhir.CodeableConcept[]|undefined;
  /**
   * Default constructor for Encounter - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IEncounter> = {}) {
    super(source);
    this.resourceType = 'Encounter';
    if (source["account"]) { this.account = source.account.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["appointment"]) { this.appointment = source.appointment.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["basedOn"]) { this.basedOn = source.basedOn.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    this.class = null;
    if (source["class"]) { this.class = new fhir.Coding(source.class!); }
    if (this.class === undefined) { this.class = null }
    if (source["classHistory"]) { this.classHistory = source.classHistory.map((x:Partial<fhir.IEncounterClassHistory>) => new fhir.EncounterClassHistory(x)); }
    if (source["diagnosis"]) { this.diagnosis = source.diagnosis.map((x:Partial<fhir.IEncounterDiagnosis>) => new fhir.EncounterDiagnosis(x)); }
    if (source["episodeOfCare"]) { this.episodeOfCare = source.episodeOfCare.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["hospitalization"]) { this.hospitalization = new fhir.EncounterHospitalization(source.hospitalization!); }
    if (source["identifier"]) { this.identifier = source.identifier.map((x:Partial<fhir.IIdentifier>) => new fhir.Identifier(x)); }
    if (source["length"]) { this.length = new fhir.Duration(source.length!); }
    if (source["location"]) { this.location = source.location.map((x:Partial<fhir.IEncounterLocation>) => new fhir.EncounterLocation(x)); }
    if (source["participant"]) { this.participant = source.participant.map((x:Partial<fhir.IEncounterParticipant>) => new fhir.EncounterParticipant(x)); }
    if (source["partOf"]) { this.partOf = new fhir.Reference(source.partOf!); }
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (source["priority"]) { this.priority = new fhir.CodeableConcept(source.priority!); }
    if (source["reasonCode"]) { this.reasonCode = source.reasonCode.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["reasonReference"]) { this.reasonReference = source.reasonReference.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["serviceProvider"]) { this.serviceProvider = new fhir.Reference(source.serviceProvider!); }
    if (source["serviceType"]) { this.serviceType = new fhir.CodeableConcept(source.serviceType!); }
    this.status = null;
    if (source["status"]) { this.status = source.status; }
    if (this.status === undefined) { this.status = null }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
    if (source["statusHistory"]) { this.statusHistory = source.statusHistory.map((x:Partial<fhir.IEncounterStatusHistory>) => new fhir.EncounterStatusHistory(x)); }
    if (source["subject"]) { this.subject = new fhir.Reference(source.subject!); }
    if (source["type"]) { this.type = source.type.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
  }
  /**
   * Check if the current Encounter contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["class"] === undefined) { missingElements.push("class"); }
    if (this["status"] === undefined) { missingElements.push("status"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Encounter from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IEncounter):Encounter {
    var dest:Encounter = new Encounter(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Encounter is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Code Values for the Encounter.statusHistory.status field
 */
export enum EncounterStatusHistoryStatusEnum {
  PLANNED = "planned",
  ARRIVED = "arrived",
  TRIAGED = "triaged",
  IN_PROGRESS = "in-progress",
  ONLEAVE = "onleave",
  FINISHED = "finished",
  CANCELLED = "cancelled",
  ENTERED_IN_ERROR = "entered-in-error",
  UNKNOWN = "unknown",
}
/**
 * Code Values for the Encounter.location.status field
 */
export enum EncounterLocationStatusEnum {
  PLANNED = "planned",
  ACTIVE = "active",
  RESERVED = "reserved",
  COMPLETED = "completed",
}
/**
 * Code Values for the Encounter.status field
 */
export enum EncounterStatusEnum {
  PLANNED = "planned",
  ARRIVED = "arrived",
  TRIAGED = "triaged",
  IN_PROGRESS = "in-progress",
  ONLEAVE = "onleave",
  FINISHED = "finished",
  CANCELLED = "cancelled",
  ENTERED_IN_ERROR = "entered-in-error",
  UNKNOWN = "unknown",
}
